// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9032f62d","787":"78aa2a5f","977":"332406bd"}[chunkId] + ".chunk.js";
};